import { Avatar, Backdrop, Button, Card, CardActions, CardContent, CardHeader, Container, Grid, IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, TextField, Tooltip, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardOutlined';
import SendIcon from '@material-ui/icons/Send';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import avatar from 'src/assets/images/technician.png';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  rootlist: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 550,
  },
  rootlistsag: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 500,
  },

  cardBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  table: {
    minWidth: 650,
  },
  content: {
    minHeight: 550,
  },
  chatSection: {
    width: '100%',
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  headBG: {
    backgroundColor: '#e0e0e0'
  },
  borderRight500: {
    borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    overflowY: 'auto'
  },
  button: {
    margin: theme.spacing(1),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
function Chat() {
  const classes = useStyles();
  const params = useParams();
  const [Kullanici, setKullanici] = useState([]);
  const [Yorum, setYorum] = useState([]);
  const [YorumDetay, setYorumDetay] = useState([]);
  const [KullaniciId, setKullaniciId] = useState(0);
  const [Loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [FisNo, setFisNo] = useState('');
  const [YorumNot, setYorumNot] = useState('');
  const SessionUser = getUser();
  const handleChangeKullanici = (param) => {
    setKullaniciId(param);
    setLoading(true);
    axios.get(`/GetYsAmbarYorum/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${param}`)
      .then(response => {
        if (response.data.length > 0) {
          setYorum(response.data);
        }
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
        setLoading(false);
      });

  }
  const GetYorumKullanici = () => {
    axios.get(`/GetDepoYorumKullanici/${0}/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`)
      .then(response => {
        if (response.data.length > 0) {
          setKullanici(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
  const YorumDetayGoster = (FIS_NO) => {
    setFisNo(FIS_NO);
    setLoading(true);
    axios.get(`/GetYsAmbarYorumDetay/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${FIS_NO}`)
      .then(response => {
        if (response.data.length > 0) {
          setYorumDetay(response.data);
        }
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
        setLoading(false);
      });

  }
  const YorumDetayGonder = () => {
    setLoading(true);
    var FisParam = 0;
    if (FisNo !== '') {
      FisParam = FisNo;
    }
    axios.get(`/SetYsAmbarYorumDetay/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${FisParam}/${SessionUser.OrganizationUserId}/${KullaniciId}/${YorumNot}`)
      .then(response => {
        YorumDetayGoster(response.data[0].ErrorDescription);
        setLoading(false);
        setYorumNot("");
      })
      .catch(error => {
        console.log(error);
        setLoading(false);
      });

  }
  useEffect(() => {
    let mounted = true;
    GetYorumKullanici();
    return () => {
      mounted = false;
    };
  }, [SessionUser.ServiceShopId, SessionUser.TechnicianId]);


  return (
    <Page className={classes.root} title="Mesajlaşma">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Mesajlaşma" />
          <Divider />
          <CardContent>
            <Backdrop className={classes.backdrop} open={Loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3}>
                <Card className={classes.cardBolum}>
                  <List>
                    <ListItem button key="Kullanici">
                      <ListItemIcon>
                        <Avatar
                          alt="Person"
                          className={classes.avatar}
                          src={avatar}
                        />
                      </ListItemIcon>
                      <ListItemText primary={SessionUser.FirstName + ' ' + SessionUser.LastName}></ListItemText>
                    </ListItem>
                  </List>
                  <Divider />
                  <Grid item xs={12} style={{ padding: '10px' }}>
                    <Autocomplete
                      id="Belirli bir kişi varsa seçiniz!..."
                      fullWidth
                      options={Kullanici}
                      classes={{
                        option: classes.option,
                      }}
                      autoHighlight
                      onChange={(event, newValue) => {
                        if (newValue === null) {
                          return;
                        }
                        handleChangeKullanici(newValue.ID);
                      }}
                      getOptionLabel={(option) => option.ADSOYAD}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Belirli bir kişi varsa seçiniz!..."
                          variant="outlined"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />



                  </Grid>
                  <Divider />
                  <List className={classes.rootlist}>
                    {Yorum
                      .map((row, index) => {
                        return (
                          <div>
                            <ListItem alignItems="flex-start">
                              <ListItemText
                                primary={row.FIS_NO + ' - ' + row.SAAT}
                                secondary={
                                  <React.Fragment>
                                    <Typography
                                      component="span"
                                      variant="body2"
                                      className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {row.TARIH}
                                    </Typography>
                                    {" — " + row.YORUM}
                                  </React.Fragment>
                                }
                              />
                              <ListItemSecondaryAction>
                                <Tooltip title="Detayları Göster">
                                  <IconButton
                                    color="primary"
                                    edge="end"
                                    onClick={(event) => YorumDetayGoster(row.FIS_NO)}
                                    size="small">
                                    <ArrowForwardIcon />
                                  </IconButton>
                                </Tooltip>
                              </ListItemSecondaryAction>
                            </ListItem>
                            <Divider component="li" />
                          </div>
                        );
                      })}
                  </List>
                </Card>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Card className={classes.cardBolum}>
                  <List>
                    <ListItem button key="Kullanici">
                      <ListItemIcon>
                        <Avatar
                          alt="Person"
                          className={classes.avatar}
                          src={avatar}
                        />
                      </ListItemIcon>
                      <ListItemText primary={FisNo}></ListItemText>
                    </ListItem>
                  </List>
                  <Divider />
                  <CardContent className={classes.content}>
                    <List className={classes.rootlistsag}>
                      {YorumDetay
                        .map((row, index) => {
                          return (
                            <ListItem key={row.SIRA_NO}>
                              <Grid container>
                                <Grid item xs={12}>
                                  <ListItemText align={row.KONUM} primary={row.YORUM}></ListItemText>
                                </Grid>
                                <Grid item xs={12}>
                                  <ListItemText align={row.KONUM} secondary={row.TARIH}></ListItemText>
                                </Grid>
                              </Grid>
                            </ListItem>
                          );
                        })}
                    </List>
                  </CardContent>
                  <Divider />
                  <CardActions>
                    <Grid container>
                      <Grid item xs={11}>
                        <TextField id="outlined-basic-email"
                          onChange={e => { setYorumNot(e.target.value) }}
                          value={YorumNot}
                          variant="outlined" label="Mesaj yazınız..." fullWidth />
                      </Grid>
                      <Grid xs={1}>
                        <Button
                          variant="contained"
                          className={classes.button}
                          color="secondary"
                          endIcon={<SendIcon></SendIcon>}
                          onClick={(event) => YorumDetayGonder()}
                        >
                          Gönder
                  </Button>
                      </Grid>
                    </Grid>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </Page >
  );
}

export default Chat;
